// Con số trên mục "Chat khách" của menu (CEO chốt 1a, 01/10/2026 — QĐ 0271):
// khách của tôi đang chờ + khách chưa ai nhận. Khách chưa ai nhận không chuông
// riêng ai, nên con số này là cách cả phòng biết còn việc.
//
// Người trông cả phạm vi (quản trị, giám đốc, trưởng phòng CSKH, Trưởng cửa
// hàng, Quản lý cụm, QC — CEO chốt 1a 27/10/2026) nhìn TỔNG khách đang chờ, kể
// cả khách đã có người phụ trách, để thấy chỗ bị sót. Ai thuộc nhóm đó là máy
// chủ quyết (`showTotal`), giao diện không tự đoán vai.
import { useQuery } from "@tanstack/react-query";
import type { Staff } from "@/lib/authv2/store";
import { fetchChatWaitingCount } from "./api";
import { canReplyCustomerChats } from "./permissions";
import { WAITING_COUNT_KEY } from "./query-keys";

/**
 * Chỉ người TRẢ LỜI được khách mới hỏi máy chủ: phòng chỉ xem không có việc
 * phải trả lời (máy chủ cũng trả 0 cho họ), người không vào được hộp thư thì
 * cửa này trả 403. Lỗi mạng ⇒ 0 — menu không vỡ vì một con số.
 */
export function useChatWaitingBadge(staff: Staff | null): number {
  const enabled = canReplyCustomerChats(staff);
  const q = useQuery({
    queryKey: WAITING_COUNT_KEY,
    enabled,
    refetchInterval: enabled ? 30_000 : false,
    staleTime: 20_000,
    queryFn: ({ signal }) => fetchChatWaitingCount(signal),
  });
  if (!enabled || !q.data) return 0;
  return q.data.showTotal ? q.data.total : q.data.mine + q.data.unassigned;
}
